import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { Component } from 'react';
import styles from '../styles/original-email-modal.module.scss';
const PROP_MAP = {
    rewritten_html: 'htmlIframeSrc',
    html: 'orginalHtmlIframeSrc',
    text: 'emailText',
};
class OriginalEmailModal extends Component {
    constructor(props) {
        super(props);
        this.getHtmlEmail = () => {
            this.getOriginalEmailByType('rewritten_html');
        };
        this.getOrginalHtmlEmail = () => {
            this.getOriginalEmailByType('html');
        };
        this.getTextEmail = () => {
            this.getOriginalEmailByType('text');
        };
        this.state = {
            showRewrittenHtmlRawEmail: false,
            showOriginalHtmlEmail: false,
            showOriginalHtmlRawEmail: false,
            showTextEmail: false,
            showAllData: false,
            htmlIframeSrc: '',
            emailText: '',
            orginalHtmlIframeSrc: '',
        };
    }
    getOriginalEmailByType(type) {
        const { currentOriginalEmail } = this.props.originalEmail;
        const original = currentOriginalEmail[type];
        const prop = PROP_MAP[type] || 'htmlIframeSrc';
        (original
            ? Promise.resolve(original)
            : this.props.originalEmailHtmlGetByType({
                type,
                url: `${currentOriginalEmail.requestURL}`,
            }))
            .then((response) => {
            this.setState({ [prop]: response });
        })
            .catch((exception) => {
            console.error('Exception', exception);
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.originalEmail.ui.showModal === true &&
            prevProps.originalEmail.ui.showModal === false) {
            this.getHtmlEmail();
            this.getTextEmail();
            this.getOrginalHtmlEmail();
        }
        else if (this.props.originalEmail.ui.showModal === false &&
            prevProps.originalEmail.ui.showModal === true) {
            // Reset state when closing the modal.
            this.setState({
                showRewrittenHtmlRawEmail: false,
                showOriginalHtmlEmail: false,
                showOriginalHtmlRawEmail: false,
                showTextEmail: false,
                showAllData: false,
                htmlIframeSrc: '',
                emailText: '',
                orginalHtmlIframeSrc: '',
            });
        }
    }
    render() {
        return (_jsxs(Modal, Object.assign({ className: styles.originalEmailModal, isOpen: this.props.originalEmail.ui.showModal, onClose: this.props.originalEmailCloseModal, allowClickOutside: true, allowEscClose: true }, { children: [_jsx(ModalHead, { title: "View original email", onClose: this.props.originalEmailCloseModal }), _jsxs(ModalBody, { children: [_jsxs("div", { children: [_jsx("h3", Object.assign({ className: "header" }, { children: "Rewritten HTML email" })), _jsxs("pre", { children: [_jsx(Button, Object.assign({ className: styles.toggleHtmlRaw, onClick: () => {
                                                this.setState({
                                                    showRewrittenHtmlRawEmail: !this.state.showRewrittenHtmlRawEmail,
                                                });
                                            } }, { children: this.state.showRewrittenHtmlRawEmail === true
                                                ? 'Hide source'
                                                : 'Show source' })), this.state.showRewrittenHtmlRawEmail === false && (_jsx("iframe", { srcDoc: `${this.state.htmlIframeSrc}`, style: { border: '0', width: '100%', height: '100vh' }, sandbox: "" })), this.state.showRewrittenHtmlRawEmail === true && (_jsx("iframe", { src: `data:text/plain;charset=utf-8,${this.state.htmlIframeSrc}`, style: { border: '0', width: '100%', height: '100vh' }, sandbox: "" }))] })] }), _jsxs("div", { children: [_jsxs("h3", Object.assign({ className: "header" }, { children: ["Original HTML email", ' ', _jsx(Button, Object.assign({ onClick: () => {
                                                this.setState({
                                                    showOriginalHtmlEmail: !this.state.showOriginalHtmlEmail,
                                                });
                                            } }, { children: this.state.showOriginalHtmlEmail === true
                                                ? 'Hide original HTML email'
                                                : 'View original HTML email' }))] })), this.state.showOriginalHtmlEmail === true &&
                                    this.state.orginalHtmlIframeSrc !== '' && (_jsxs("pre", { children: [_jsx(Button, Object.assign({ className: "toggle-html-raw", onClick: () => {
                                                this.setState({
                                                    showOriginalHtmlRawEmail: !this.state.showOriginalHtmlRawEmail,
                                                });
                                            } }, { children: this.state.showOriginalHtmlRawEmail === true
                                                ? 'Hide source'
                                                : 'Show source' })), this.state.showOriginalHtmlRawEmail === false && (_jsx("iframe", { srcDoc: `${this.state.orginalHtmlIframeSrc}`, style: {
                                                border: '0',
                                                width: '100%',
                                                height: '100vh',
                                            }, sandbox: "" })), this.state.showOriginalHtmlRawEmail === true && (_jsx("iframe", { src: `data:text/plain;charset=utf-8,${this.state.orginalHtmlIframeSrc}`, style: {
                                                border: '0',
                                                width: '100%',
                                                height: '100vh',
                                            }, sandbox: "" }))] }))] }), _jsxs("div", { children: [_jsxs("h3", Object.assign({ className: "header" }, { children: ["Plain text email", ' ', _jsx(Button, Object.assign({ onClick: () => {
                                                this.setState({
                                                    showTextEmail: !this.state.showTextEmail,
                                                });
                                            } }, { children: this.state.showTextEmail === true
                                                ? 'Hide text email'
                                                : 'View text email' }))] })), this.state.showTextEmail === true &&
                                    this.state.emailText !== '' && (_jsx("pre", Object.assign({ style: { whiteSpace: 'pre-wrap' } }, { children: this.state.emailText })))] }), _jsxs("div", { children: [_jsxs("h3", Object.assign({ className: "header" }, { children: ["Email data", ' ', _jsx(Button, Object.assign({ onClick: () => {
                                                this.setState({ showAllData: !this.state.showAllData });
                                            } }, { children: this.state.showAllData === true
                                                ? 'Hide email data'
                                                : 'View email data' }))] })), this.props.originalEmail.currentOriginalEmail &&
                                    this.state.showAllData === true && (_jsx("pre", { children: JSON.stringify(this.props.originalEmail.currentOriginalEmail.msg ||
                                        this.props.originalEmail.currentOriginalEmail, null, 2) }))] })] }), _jsx(ModalFoot, { children: _jsx("div", Object.assign({ className: "buttons" }, { children: _jsx(Button, Object.assign({ type: "button", onClick: this.props.originalEmailCloseModal }, { children: "Close" })) })) })] })));
    }
}
export default OriginalEmailModal;
